export function isInsideIframe() {
  return window.self !== window.top;
}
